import {
    Component,
    Input,
    HostBinding
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'app-market-resource-price',
    templateUrl: './resource-price.component.pug',
    styleUrls: ['./resource-price.component.less']
})
export class ResourcePriceComponent {
    @HostBinding('class.--ui') _ui = true;

    @Input() data: any = {};
    get hasPrice() {
        return this.data.hasOwnProperty('avgPrice');
    }

    get noData() {
        return !this.data.count;
    }

    constructor(
    ) {
    }
}
